import Styled from 'styled-components'
import { Link } from 'react-router-dom'
import InfoIcon from '../../assets/info-icon'

const StyledBannerAnnouncing = Styled.div`
    margin: 60px auto;
    font-size: 24px;
    letter-spacing: -0.7px;
    line-height: 28px;
    border-radius: 20px;
    background-color: #DBE6FF;
    color: ${({ theme }) => theme.colors.black};
    font-weight: 700;
    display: flex;
    padding: 16px;
    max-width: 1080px;
    font-family: 'Lato', sans-serif;
    p {
        margin: 0;
    }

    .wrap-image {
      width: 36px;
      height: 36px;
      margin-right: 10px;
      border-radius: 50%;
      background-color: #074EE8;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      svg {
        width: 28px;
        height: 28px;
      }
      @media (min-width: ${({ theme }) => theme.breakPoints.xSmall}) {
        width: 50px;
        height: 50px;
        svg {
          width: 36px;
          height: 36px;
      }
      }
    }

    a {
      color: #074EE8;
      text-decoration: underline;
    }
    
   

  @media (max-width: ${({ theme }) => theme.breakPoints.small}) {
    margin: 32px 8px 32px;
    font-size: 20px;
    line-height: 24px;
  }
`
const shouldShowBanner = () => {
  const currentDate = new Date()
  const endDate = new Date(2026, 0, 1) // January 1st, 2026 (months are 0-indexed)
  return currentDate < endDate
}
const BannerAnnouncing = () => {
  if (!shouldShowBanner()) return null
  return (
    <StyledBannerAnnouncing>
      <div className="wrap-image">
        <InfoIcon color="white" />
      </div>
      <p>
        <strong>Notice: </strong>
        Please be advised that our Terms & Conditions have been
        updated. You may review them here:{' '}
        <Link to="/terms-conditions">Terms & Conditions</Link>
      </p>
    </StyledBannerAnnouncing>
  )
}

export default BannerAnnouncing
